import axios from "axios";
import {
  GET_CMS_CONTENT,
  LOAD_CMS_CONTENT,
  GET_QUESTION_ANSWER,
} from "./types";

const PROXY = process.env.REACT_APP_URL + "api/";

export const getContentDetails = (slug, code) => async (dispatch) => {
  try {
    loadContentDetails(dispatch);
    const res = await axios.get(
      `${PROXY}cms/website/new?slug=${slug}&language=${code}`
    );

    dispatch({
      type: GET_CMS_CONTENT,
      payload: res.data.result,
    });

    return res.data.result;
  } catch (error) {
    dispatch({
      type: GET_CMS_CONTENT,
      payload: null,
    });
    return error;
  }
};

export const getQuestionAnswer = () => async (dispatch) => {
  try {
    const res = await axios.get(`${PROXY}que_ans/website`);
    dispatch({
      type: GET_QUESTION_ANSWER,
      payload: res.data.result,
    });

    return res.data.result;
  } catch (error) {
    console.log(error);
  }
};

export const loadContentDetails = (dispatch) => {
  dispatch({
    type: LOAD_CMS_CONTENT,
  });
};
